<template>
  <div class="important-page-c display--flex fd--column">
    <div v-if="!goPrint">
    <!-- 搜索 -->
    <div class="search-form btn-2b5a95">
      <div
        class="l-w"
        :style="{
          height: $store.state.global.isSearchExtend_1
            ? ''
            : $store.state.global.searchFormHeight_1 + 10 + 'px',
        }"
      >
        <el-form
          label-position="right"
          :class="
            $store.state.global.isSearchExtend_1 ? '' : 'overflow--hidden'
          "
					:model="searchForm"
					@submit.native.prevent
        >
          <el-form-item label="会议名称:">
            <el-input
							v-model.trim="searchForm.title"
							@keyup.enter.native="seach"
							clearable />
          </el-form-item>
          <el-form-item label="会议时间:">
            <el-input
                    v-model.trim="searchForm.meetingtime"
                    @keyup.enter.native="seach"
                    clearable />
          </el-form-item>
          <el-form-item label="记录人:">
            <el-input
							v-model.trim="searchForm.insertusername"
							@keyup.enter.native="seach"
							clearable />
          </el-form-item>

          <el-form-item label="审核状态:">
            <el-select
                    v-model="searchForm.approveflag"
                    @keyup.enter.native="seach"
                    @visible-change="approVisible"
                    ref="approveref"
                    clearable>
              <el-option value="1" label="通过"></el-option>
              <el-option value="0" label="不通过"></el-option>
              <el-option value="-1" label="审核中"></el-option>
              <el-option value="-2" label="未提请审批"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="教学点:">
            <el-input
							v-model.trim="searchForm.schoolorgname"
							@keyup.enter.native="seach"
							clearable />
          </el-form-item>
        </el-form>
      </div>
      <div class="r-w">
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="getDataList"
          :loading="!$store.state.global.isEndRequest"
          class="btn-2b5a95"
          >搜索</el-button
        >
				<el-button type="primary" @click="resetQuery">重置</el-button>
        <el-button
          type="primary"
          :icon="
            $store.state.global.isSearchExtend_1
              ? 'el-icon-arrow-up'
              : 'el-icon-arrow-down'
          "
          v-if="$store.state.global.searchExtend_1"
          class="btn-2b5a95"
          @click="onExtendClick('isSearchExtend_1')"
          >{{ $store.state.global.searchExtendText_1 }}</el-button
        >
      </div>
    </div>

    <!-- 按钮操作 -->
    <div
      class="Btn-w eaf4ff-btn"
      :style="{
        height: $store.state.global.isBtnExtend_1
          ? ''
          : $store.state.global.BtnHeight_1 + 10 + 'px',
      }"
    >
      <div
        class="btn-l"
        v-if="tableRes.buttonlist"
        :class="$store.state.global.isBtnExtend_1 ? '' : 'overflow--hidden'"
      >
        <el-button
          v-for="(item, index) in tableRes.buttonlist"
          :key="index"
          type="primary"
          @click="onClickBtn(item.buttonname)"
          >{{ item.name }}
        </el-button>
      </div>
      <div class="Btn-extend">
        <el-button
          type="primary"
          v-if="$store.state.global.btnExtend_1"
          :icon="
            $store.state.global.isBtnExtend_1
              ? 'el-icon-arrow-up'
              : 'el-icon-arrow-down'
          "
          @click="onExtendClick('isBtnExtend_1')"
          >展开</el-button
        >
      </div>
    </div>

    <!-- 表格 -->
    <el-table
			stripe
			border
			:header-cell-style="{ background: '#044d8c', color: '#fff'}"
      :data="tableRes.list"
      ref="multipleTable"
      style="width: 100%"
      @selection-change="handleSelectionChange"
      stripe
    >
      <el-table-column type="selection" width="55" />
      <el-table-column label="会议名称" prop="title" align="center" width="250" :show-overflow-tooltip="true" />
      <el-table-column label="会议时间" prop="meetingtime" align="center"/>
      <el-table-column label="主持人" prop="hostusername" align="center"/>
      <el-table-column label="记录人" prop="insertusername" align="center"/>
      <el-table-column label="审核状态" prop="approveflag" align="center">
        <template slot-scope="scope">
          {{ approveflag[scope.row.approveflag] }}
        </template>
      </el-table-column>
      <el-table-column label="审核人" prop="approveusername" align="center"/>
      <el-table-column label="审核意见" prop="approvedesc" align="center"/>
      <el-table-column label="录入时间" align="center" width="120">
        <template slot-scope="scope">
          {{ scope.row.inserttime | formatDate("YYYY-MM-DD") }}
        </template>
      </el-table-column>

      <el-table-column label="教学点" prop="schoolorgname" align="center" />
      <el-table-column label="文件路径" prop="fileurl"  v-if="showDateColumn" align="center"/>
      <el-table-column label="操作" align="center" class-name="btn-2b5a95" fixed="right" width="300">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="small"
            @click="btnShowDetail(scope.row)"
            >查看</el-button
          >
          <el-button
                type="primary"
                size="small"
                @click="printCheck(scope.row.id)"
        >打印</el-button>

          <el-button
                  type="primary"
                  size="small"
                  @click="btnUpload(scope.row.id)"
          >上传</el-button>

          <el-button
                  type="primary"
                  size="small"
                  @click="openImage(scope.row.fileurl)"
          >下载</el-button>

        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      background
      @current-change="handleCurrentChange"
      :current-page="pageinfo.pageindex"
      :page-size="pageinfo.pagesize"
      :page-sizes="[10, 20, 30, 40, 50]"
      layout="total, prev, pager, next, jumper"
      :total="tableRes.totalcount"
    ></el-pagination>
    </div>
    <!-- 打印页 -->
    <Print
            @switchPrint="switchPrint"
            :id="itemId"
            :printUrl="printUrl"
            :resKey="'vmeeting'"
            v-else
    ></Print>

    <!-- 添加, 修改 -->
    <el-dialog
      class="btn-2b5a95"
			v-dialogDrag
      width="60%"
			:close-on-click-modal='false'
      :visible.sync="showAddModal"
      v-if="showAddModal"
      append-to-body
			:title="this.dialogTitle"
    >
      <el-form
        label-width="100px"
        :model="dynamicValidateForm"
        ref="dynamicValidateForm"
        :rules="rules"
        class="form-item-w-100"
      >

        <el-row type="flex" justify="center" >
          <el-col :span="2" >
            <h2>会议纪要</h2>
          </el-col>
        </el-row>

        <br></br>

        <el-row :gutter="20">
          <el-col  :span="12">
              <el-form-item prop="companyorgname" label="所属分公司">
                <el-select
                        v-model="dynamicValidateForm.companyorgname"
                        placeholder="请选择"
                        :disabled="!$store.state.login.isMaxAuth"
                        clearable
                        @change="onChangeCompany($event, 'dynamicValidateForm')"
                >
                  <el-option
                          v-for="item in $store.state.selectData.companyList"
                          :key="item.key"
                          :label="item.val"
                          :value="item.key"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
          </el-col>
            <el-col  :span="12">
                <el-form-item prop="schoolorgname" label="所属教学点">
                  <el-select
                          v-model="dynamicValidateForm.schoolorgname"
                          placeholder="请选择"
                          clearable
                          @change="onChangeSchool($event, 'dynamicValidateForm')"
                  >
                    <el-option
                            v-for="item in $store.state.selectData.schoolList"
                            :key="item.key"
                            :label="item.val"
                            :value="item.key"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
            </el-col>
        </el-row>

        <el-form-item label="会议名称" prop="title">
          <el-input v-model.trim="dynamicValidateForm.title" clearable></el-input>
        </el-form-item>

        <el-form-item label="主题词" prop="terms">
          <el-input v-model.trim="dynamicValidateForm.terms" clearable></el-input>
        </el-form-item>

        <el-row :gutter="20">
          <el-col  :span="12">
            <el-form-item label="会议时间" prop="meetingtime">
              <el-input v-model.trim="dynamicValidateForm.meetingtime" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col  :span="12">
                <el-form-item label="会议地点" prop="address">
                  <el-input v-model.trim="dynamicValidateForm.address" clearable></el-input>
                </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col  :span="12">
            <el-form-item label="主持人" prop="hostusername">
              <el-input v-model.trim="dynamicValidateForm.hostusername" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col  :span="12">
            <el-form-item label="记录人" prop="insertusername">
              <el-input v-model.trim="dynamicValidateForm.insertusername" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="参会人员" prop="participants">
          <el-input v-model.trim="dynamicValidateForm.participants" clearable></el-input>
        </el-form-item>

        <el-row type="flex" justify="center">
          <el-col :span="2">
            <el-form-item label="会议主要内容"/>
          </el-col>
        </el-row>

        <el-input v-model.trim="dynamicValidateForm.content" type="textarea" :rows="6" clearable></el-input>

        <el-row type="flex" justify="center">
          <el-col :span="2">
            <el-form-item label="会议决议"/>
          </el-col>
        </el-row>

        <el-input v-model.trim="dynamicValidateForm.resolution" type="textarea" :rows="6" clearable></el-input>


      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="submitAddOrEditForm('dynamicValidateForm')"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <!-- 审批 -->
    <el-dialog
            class="btn-2b5a95"
            width="35%"
            v-dialogDrag
            title="审批："
            :close-on-click-modal='false'
            :visible.sync="showApproveModal"
            append-to-body
    >
      <el-form
              :model="approveForm"
              ref="approveForm"

              class="demo-dynamic form-item-w-100"
              status-icon
              :rules="rules"
      >

        <el-form-item
                label="审核是否通过："
                prop="passflag"
                :rules="[
            {
              required: true,
              message: '必填字段',
              trigger: 'blur',
            },
          ]"
        >
          <el-select
                  v-model="approveForm.passflag"
                  placeholder="请选择"
                  clearable
          >
            <el-option
                    v-for="item in [
                { value: 1, label: '通过' },
                { value: 0, label: '不通过' },
              ]"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="approvedesc" label="审批意见：">
          <el-input
                  type="textarea"
                  v-model.trim="approveForm.approvedesc"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitApproveForm('approveForm')"
        >提交
        </el-button>
      </span>
    </el-dialog>

    <!-- 查看详情 -->
    <el-dialog
            class="btn-2b5a95"
            :close-on-click-modal='false'
            :width="$store.state.global.isFullscreen ? 'width: 100%' : 'width: 80%'"

            :visible.sync="showDetailModal"
            v-if="showDetailModal"
            append-to-body
            @closed="$store.state.global.isFullscreen = false"
    >
      <span slot="title" class="el-dialog__title">
        <span>会议纪要</span>
        <span
                :class="
            $store.state.global.isFullscreen
              ? 'el-icon-copy-document'
              : 'el-icon-full-screen'
          "
                @click="isExpand($store.state.global.isFullscreen)"
        ></span>
      </span>
      <div class="print-c-t">
          <h1>（{{ dynamicValidateForm.schoolorgname }}）</h1>
          <h1>会议纪要</h1>
          <div class="print-table-w">
              <table border="1" cellpadding="10" cellspacing="0" width="900px">
                    <tr>
                      <td class="td-style">会议名称</td>
                      <td class="td-style" colspan="3">{{ dynamicValidateForm.title }}</td>
                    </tr>

                    <tr>
                      <td class="td-style">主题词</td>
                      <td class="td-style" colspan="3">{{ dynamicValidateForm.terms }}</td>
                    </tr>

            <tr>
              <td class="td-style">会议时间</td>
              <td class="td-style5">{{ dynamicValidateForm.meetingtime }}</td>
              <td class="td-style">会议地点</td>
              <td class="td-style5">{{ dynamicValidateForm.address }}</td>
            </tr>

            <tr>
              <td class="td-style">主持人</td>
              <td class="td-style">{{ dynamicValidateForm.hostusername }}</td>
              <td class="td-style">记录人</td>
              <td class="td-style">{{ dynamicValidateForm.insertusername }}</td>
            </tr>

            <tr>
              <td class="td-style">参会人员</td>
              <td class="td-style" colspan="3">{{ dynamicValidateForm.participants }}</td>
            </tr>

            <tr>
              <td class="td-style2" colspan="4">会议主要内容</td>
            </tr>

            <tr>
              <td class="td-style3" colspan="4">{{dynamicValidateForm.content}}</td>
            </tr>

            <tr>
              <td class="td-style2" colspan="4">会议决议</td>
            </tr>

            <tr>
              <td class="td-style3" colspan="4">{{dynamicValidateForm.resolution}}</td>
            </tr>

            <tr>
              <td style="font-size:18px;">参会人员签名<br></br>
                （单位盖章）</td>
              <td colspan="3" class="td-style4">（单位名称盖章）</td>
            </tr>

            <tr>
              <td class="td-style">审核人批注</td>
              <td class="td-style" colspan="3"></td>
            </tr>

            <tr>
              <td class="td-style">抄送</td>
              <td colspan="3" style="font-size:18px;">（{{dynamicValidateForm.approveusername}}）办公室、行政后勤中心（存档）、王祝安办公室</td>
            </tr>
          </table>
          </div>
      </div>
    </el-dialog>

    <!-- 上传纪要 -->
    <el-dialog
            class="btn-2b5a95"
            width="35%"
            v-dialogDrag
            :title="dialogTitle"
            :close-on-click-modal='false'
            :visible.sync="showMeetingModal"
            v-if="showMeetingModal"
            append-to-body
    >
      <el-form
              :model="dynamicValidateForm"
              ref="dynamicValidateForm"

              class="demo-dynamic form-item-w-100"
              status-icon
              :rules="rules"
      >
        <el-form-item label="会议纪要：" prop="fileurl">
          <el-upload
                  class="upload-demo"
                  :action="$store.state.global.baseUrl"
                  multiple
                  :before-upload="beforeUpload"
                  :http-request="uploadFile"
          >
            <el-button size="small" type="primary" class="select-btn">点击上传</el-button>
            <div slot="tip" class="el-upload__tip"></div>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
                type="primary"
                @click="submitFileurl('dynamicValidateForm')"
                :loading="!$store.state.global.isEndRequest"
        >提交
        </el-button>
      </span>
    </el-dialog>


  </div>
</template>

<script>
  import { _approveflag } from "@/assets/js/filedValueFlag";
import { part } from "@/utils/mixins";
import { mapActions } from "vuex";

import {
  meeting_list,
  meeting_delete,
  meeting_input,
  meeting_save,
  meeting_approvecheck,
  meeting_requestapprove,
  meeting_approvesave,
  meeting_printcheck,
  meeting_print,
  meeting_show,
  meeting_uploadsave,
} from "@/request/api/allChildrenProject";
import { myRequest } from "@/request/index";
import {} from "@/assets/js/initTableData";
import { _user_dialogresult } from "@/request/api/public";
  import { _fileupload_save, _filedownload_save } from "@/request/api/public";
import {
  selectCheck,
  confirmCallBack,
  messageTip,
  createObjParams,
  formatDare,
} from "@/utils/util";
import {} from "@/assets/js/filedValueFlag";
  import Print from "@/components/public/meetingprint.vue";
export default {
  mixins: [part],
  name: "meeting",
  components: {Print,},
  props: {
    user_dialogresult: {
      default: () => _user_dialogresult,
    },
    printUrl: {
      default: () => meeting_print,
    },
  },
  data() {
    return {
      searchForm: {}, //搜索表单
      tableRes: {}, //列表接口
			dialogTitle: "", //对话框标题
      pageinfo: {
        pageindex: 1,
        pagesize: 10,
      }, //页数查询
      showAddModal: false, //显示表单框
      fds: new FormData(),
      fileList: [], // 存储图像的数组
      multipleSelection: [], //选中的表格项
      dynamicValidateForm: {}, //表单
      rules: {
        title: [{ trigger: "blur", message: "必填字段", required: true }],
        terms: [{ trigger: "blur", message: "必填字段", required: true }],
        meetingtime: [{ trigger: "blur", message: "必填字段", required: true }],
        address: [{ trigger: "blur", message: "必填字段", required: true }],
        hostusername: [{ trigger: "blur", message: "必填字段", required: true }],
        insertusername: [{ trigger: "blur", message: "必填字段", required: true }],
        participants: [{ trigger: "blur", message: "必填字段", required: true }],
        content: [{ trigger: "blur", message: "必填字段", required: true }],
        resolution: [{ trigger: "blur", message: "必填字段", required: true }],
        companyorgname: [
          { trigger: "blur", message: "必填字段", required: true },
        ],
        schoolorgname: [
          { trigger: "blur", message: "必填字段", required: true },
        ],
        approveflag: [{ trigger: "blur", message: "必填字段", required: true }],
        passflag: [{ trigger: "blur", message: "必填字段", required: true }],

      },
      approveflag: _approveflag,
      approveForm: {}, //审批表单
      showApproveModal: false,
      key: '',
      //isApprovePass: _isApprovePass, //审核是否通过标记
      goPrint: false, //前往打印页
      showDetailModal:false,
      showMeetingModal:false,
      showDateColumn: false, // 隐藏文件路径
    };
  },
  created() {
    this.searchForm.id = this.$route.params.id;
    this.getDataList();
    this.org_combox();
    this.org_comboxchild(this.dynamicValidateForm.companyorgid);
    window.addEventListener("keyup", this.enterSelect);
  },
  methods: {
    ...mapActions("global", ["onExtendClick", "isExpand"]),
    ...mapActions("selectData", ["org_combox", "org_comboxchild"]),
    //切换到打印页
    switchPrint(data) {
      this.goPrint = data;
      this.multipleSelection = [];
    },
    //改变分公司 change
    onChangeCompany(val, form) {
      this[form].schoolorgname = "";
      this[form].companyorgid = val;
      this.org_comboxchild(val);
    },
    //改变教学点 change
    onChangeSchool(val, form) {
      this[form].schoolorgid = val;
    },
    approVisible(e) {
      if(!e) {
        this.$refs.approveref.blur();
      }
    },
		reset() {
			this.searchForm = {
				title: null,
                meetingtime:null,
                approveflag: null,
                insertusername:null,
				schoolorgname: null
			}
		},
		resetQuery() {
			this.reset();
			this.getDataList();
		},
    //搜索 click
    seach() {
      this.pageinfo.pageindex = 1;
      this.getDataList();
    },
    //列表查询 api
    getDataList() {
      myRequest({
        url: meeting_list,
        data: Object.assign(this.searchForm, this.pageinfo),
      }).then((res) => {
        if (res.data.code === "200") {
          this.tableRes = res.data.data;
        }
      });
    },
    //切换当前页
    handleCurrentChange(val) {
      this.pageinfo.pageindex = val;
      this.getDataList();
    },
    //触发所有btn方法
    onClickBtn(methodsName) {
      this.$options.methods[methodsName].call(this); //btnAdd ... （防止修改this指向）
    },
    // 添加
    btnAdd() {
      this.showAddModal = true;
      this.dialogTitle = "添加";
      this.dynamicValidateForm = {
        schoolorgid: this.$store.state.login.userinfo.schoolorgid,
        companyorgid: this.$store.state.login.userinfo.companyorgid,
        title: null,
        meetingtime: null,
        introduction: null,
        summary: null,
        signin: null,

      };
      this.$set(
              this.dynamicValidateForm,
              "companyorgname",
              this.$store.state.login.userinfo.companyorgname
      );
      this.$set(
              this.dynamicValidateForm,
              "schoolorgname",
              this.$store.state.login.userinfo.schoolorgname
      );
      this.org_comboxchild(this.dynamicValidateForm.companyorgid);
      this.showAddModal = true;
    },

    // 修改 click
    btnEdit() {
			this.dialogTitle = "修改";
      selectCheck(this.multipleSelection, "修改", false, () => {
        this.editRoute(this.multipleSelection[0].id);
      });
    },

    // 修改 api
    editRoute(id) {
      myRequest({
        url: meeting_input,
        data: {
          id: id,
        },
      }).then((res) => {
        if (res.data.code === "200") {
          this.dynamicValidateForm = res.data.data.vmeeting;
          delete this.dynamicValidateForm.inserttime; // inserttime不用传
          delete this.dynamicValidateForm.approveflag;
          delete this.dynamicValidateForm.approveuserid;
          delete this.dynamicValidateForm.approvetime;
          delete this.dynamicValidateForm.approvedesc;
          this.showAddModal = true;
        }
      });
    },

    // 添加确定 click api
    submitAddOrEditForm(dynamicValidateForm) {
      this.$refs[dynamicValidateForm].validate((valid) => {
        if (valid) {
          myRequest(
            {
              url: meeting_save,
              data: this.dynamicValidateForm,
            },
            {
              isRefTableList: true,
              that: this,
              modal: "showAddModal",
            }
          );
        }
      });
    },

    //删除表格项 click
    btnDel() {
      selectCheck(this.multipleSelection, "删除", true, () => {
        confirmCallBack({
          title: "提示",
          content: "此操作将永久删除选中的数据！",
          success: () => {
            this.delTableItem(this.multipleSelection.map((i) => i.id));
          },
          fail: () => {
            messageTip({
              message: "取消操作",
              type: "info",
            });
          },
        });
      });
    },

    //删除表格项 api
    delTableItem(idArr) {
      myRequest(
        {
          method: "post",
          url: meeting_delete,
          data: this.$qs.stringify(
            {
              ids: idArr,
            },
            {
              arrayFormat: "repeat",
            }
          ),
        },
        {
          isRefTableList: true,
          that: this,
        }
      );
    },

    //提请审批 api
    reqApproval(ids) {
      myRequest(
              {
                method: "post",
                url: meeting_requestapprove,
                data: this.$qs.stringify(
                        {
                          id: ids,
                        },
                        {
                          arrayFormat: "repeat",
                        }
                ),
              },
              {
                isRefTableList: true,
                that: this,
              }
      );
    },

    //提请审批 click
    btnRequestApprove() {
      selectCheck(this.multipleSelection, "提请审批", false, () => {
        confirmCallBack({
          title: "提示",
          content: "选中的条目将提请审批！",
          success: () => {
            this.reqApproval(this.multipleSelection.map((i) => i.id));
          },
          fail: () => {
            messageTip({
              message: "取消操作",
              type: "info",
            });
          },
        });
      });
    },

    //教学点负责人审核 click
    btnSchoolHead() {
      selectCheck(this.multipleSelection, "教学点负责人审核", true, () => {
        //this.approveForm.id = this.multipleSelection[0].id;
        myRequest({
          url: meeting_approvecheck,
          data:{
            id:this.multipleSelection[0].id,
          },
        }).then((res) => {
          if (res.data.code === "200") {
            this.approveForm = {
              passflag: null,
              approvedesc: null,
              id:this.multipleSelection[0].id,
            };
            this.showApproveModal = true;
          }
        });
      });

    },

    //审批 保存
    submitApproveForm(approveForm) {
      //this.approveForm.passflag = this.isApprovePass[this.approveForm.passflag];
      this.$refs[approveForm].validate((valid) => {
        if (valid) {
          myRequest(
                  {
                    url: meeting_approvesave,
                    data: this.approveForm,
                  },
                  {
                    that: this,
                    isRefTableList: true,
                    modal: "showApproveModal",
                  }
          );
        }
      });
    },

    // 查看详情 click
    btnShowDetail(row) {
      this.dynamicValidateForm = JSON.parse(JSON.stringify(row))
      this.showDetailModal = true;
    },

    //查看
    btnshow(id) {
      //var id = this.multipleSelection[0].id;
      myRequest({
        url: meeting_show,
        data: {
          id: id,
        },
      }).then((res) => {
        if (res.data.code === "200") {
          this.goPrint = true;
          this.itemId = id;
        }
      });
    },

    //打印校验 api
    printCheck(id) {
      //var id = this.multipleSelection[0].id;
      myRequest({
        url: meeting_printcheck,
        data: {
          id: id,
        },
      }).then((res) => {
        if (res.data.code === "200") {
          this.goPrint = true;
          this.itemId = id;
        }
      });
    },

    //打印 click
    // btnPrint() {
    //   selectCheck(this.multipleSelection, "打印", false, () => {
    //     this.printCheck(this.multipleSelection[0].id);
    //   });
    // },

    //上传文件前 before
    beforeUpload(file) {
      this.fds.append("upfile", file); // 传文件
    },
    //上传文件 upload
    uploadFile() {
      myRequest({
        method: "post",
        url: _fileupload_save,
        data: this.fds,
      }).then((res) => {
        if (res.data.code === "200") {
          this.dynamicValidateForm.fileurl = res.data.url;
        }
      });
    },

    //上传纪要click
    btnUpload(id) {
      this.dialogTitle = "上传";
      this.dynamicValidateForm = {};
      this.dynamicValidateForm.id = id;
      this.showMeetingModal = true;
    },

    // 保存会议纪要
    submitFileurl(dynamicValidateForm) {
      this.$refs[dynamicValidateForm].validate((valid) => {
        if (valid) {
          myRequest(
                  {
                    url: meeting_uploadsave,
                    data: this.dynamicValidateForm,
                  },
                  {
                    isRefTableList: true,
                    that: this,
                    modal: "showAddModal",
                  }
          );
        }
      });
      this.showMeetingModal = false;

    },

    //查看会议纪要扫描件pdf（下载）
    openImage(fileurl) {
      if(fileurl == null){
        window.vue.$message({
          message: `请先上传会议纪要，再下载!`,
          type: "warning",
        });
      }else{
        var url = this.$url.upload + fileurl;
        window.open(url, '_blank');
      }

    },

    // 下载文件
    downloadFile(index, row) {
      if (index === 0) {
        if (row.summary != undefined) {
          location.href =
            this.$url.Freemarker +
            "/filedownload/save.do?fileurl=" +
            row.summary;
        }
      } else {
        if (row.signin != undefined) {
          location.href =
            this.$url.Freemarker +
            "/filedownload/save.do?fileurl=" +
            row.signin;
        }
      }
    },
    //刷新 click
    btnRefresh() {
      this.getDataList();
    },
    //选中表格数据改变时
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  },
};
</script>


<style  lang="scss">
  .minutes{
    font-size: 20px;
  }

  .print-c-t > h1 {
    text-align: center;
    font-size:26px;
  }
  .print-c-t {
    overflow: auto;
  }

  .table-container {
    display: flex;
    justify-content: center; /* 水平居中 */
    align-items: center;     /* 垂直居中 */
    height: 100vh;           /* 根据需要设置高度，如全屏 */
  }

  .td-style {
    padding: 0 !important;
    border: 1px solid black;//边框
    border-bottom: 1px solid;
    height: 45px;
    text-align: center;
    font-size:18px;
  }

  .td-style2{
    text-align: center;
    height: 45px;
    font-size:18px;
  }

  .td-style3{
    height: 200px;
    font-size:17px;
  }

  .td-style4{
    //height: 100px;
    text-align: right;
    vertical-align: bottom;
    font-size:18px;
  }

  //会议时间、会议地点
  .td-style5{
    text-align: center;
    width:230px;
    font-size:18px;
  }

  .print-table-w {
    & > table {
      & > tr:last-child {
        td {
          border-bottom: 0;
        }
      }
    }
  }
</style>
